
    <!--
 * 竖版-充值领奖
 * @LastEditTime: Wed Dec 18 2024 22:40:11 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_G8HA65"  :class="[`normal`,`u_c_G8HA65`]" ><div id="u_c_4MZY17"  :class="[`normal`,`u_c_4MZY17`]" ><div id="u_c_1MRM21"  v-if="pageData.reset_timezone[pageData.nowResetType]" :class="[`normal txtColor `,`u_c_1MRM21`]" >{{`${ langData.timezone.replace('$start', pageData.reset_timezone[pageData.nowResetType]?.start || '').replace('$end', pageData.reset_timezone[pageData.nowResetType]?.end || '') }`}}</div><div id="u_c_8HBX18"  :class="[`normal txtColor`,`u_c_8HBX18`]" ><div id="u_c_5ILV19"  v-show="!pageData.isLogin" :class="[`normal`,`u_c_5ILV19`]" >{{`${ langData.noLogin }`}}</div><div id="u_c_5TL728"  v-show="pageData.isLogin" :class="[`normal`,`u_c_5TL728`]" >{{`${ langData.nowHasMoney } ${ pageData.payDetailWithCurrency[pageData.nowResetType] || 0 }`}}</div></div><div id="u_c_57DD20"  :class="[`normal txtColor tipsFontSize`,`u_c_57DD20`]" ><div id="u_c_XO0080"  v-show="pageData.isLogin" :class="[`normal`,`u_c_XO0080`]" >{{`${ langData.nowHasMoneyTips }`}}</div><div id="u_c_Z99V79"  v-show="!pageData.isLogin" :class="[`normal`,`u_c_Z99V79`]" >{{`${ langData.loginToCheck }`}}</div></div><a id="u_c_DG4T22" href="javascript:;" :class="[`normal `,`u_c_DG4T22`]" @click="u_c_DG4T22_event_UCCO40($event)">{{`${ langData.refresh }`}}</a><div id="u_c_EM0285"  v-if="compData.awardList.filter(item => item.reset === (compData.nowPreviewType || pageData.nowResetType)).length > 0" :class="[`normal `,`u_c_EM0285`]" ><div id="u_c_PLQE86"  v-for="(levelItem, levelIndex) in compData.awardList.filter(item => item.reset === (compData.nowPreviewType || pageData.nowResetType))[0].level" :key="levelIndex" :data-index="levelIndex" :class="[`normal level-item`,`u_c_PLQE86`]" ><a id="u_c_QY0H88" href="javascript:;" v-show="compData.awardInfoBtn" :class="[`normal`,`u_c_QY0H88`]" @click="u_c_QY0H88_event_CJ5D36($event,levelItem.giftName)">{{`${ langData.awardInfoBtn }`}}</a><div id="u_c_V9GG87"  :class="[`normal txtColor`,`u_c_V9GG87`]" >{{`${ langData.totalMoneyTips.replace('xxx', levelItem.levelWithCurrency || 0) }`}}</div><div id="u_c_20QV21"  :class="[`normal`,`u_c_20QV21`]" ><div id="u_c_11Y490"  v-for="(imgItem, imgIndex) in levelItem.gift" :key="imgIndex" :class="[`normal`,`u_c_11Y490`]" ><div id="u_c_NFW650"  :style="`background-image:url(${ imgItem.special || compData.commonBg })`" :class="[`normal`,`u_c_NFW650`]" ></div><div id="u_c_L7EQ52"  :style="`background-image:url(${ imgItem.pic })`" :class="[`normal`,`u_c_L7EQ52`]" ></div><div id="u_c_ZHKH20"  v-html="`${ imgItem.num }`" v-if="imgItem.num" :class="[`normal`,`u_c_ZHKH20`]" ></div></div></div><a id="u_c_TWA791" href="javascript:;" v-show="pageData.isEdit || levelItem.state == 0" :class="[`normal award-btn`,`u_c_TWA791`]" @click="u_c_TWA791_event_YQ8637($event,levelItem.levelToGetAward,pageData.nowResetType,levelIndex)">{{`${ langData.getBtn }`}}</a><a id="u_c_7B8431" href="javascript:;" v-show="levelItem.state == -1" :class="[`normal award-btn`,`u_c_7B8431`]" @click="u_c_7B8431_event_A5YB17($event)">{{`${ langData.gotoStore }`}}</a><a id="u_c_9MI432" href="javascript:;" v-show="levelItem.state == 1" :class="[`normal award-btn`,`u_c_9MI432`]" >{{`${ langData.hasBtn }`}}</a><div id="u_c_VO2492"  :class="[`normal txtColor`,`u_c_VO2492`]" >{{`${ langData.nowProgress }:${ +pageData.payDetailMap[pageData.nowResetType] > +levelItem.level ? levelItem.level : pageData.payDetailMap[pageData.nowResetType] || 0 }/${ levelItem.level || 0 }`}}</div></div></div></div><div id="u_c_6FWW23"  v-show="compData.viewState" :class="[`normal`,`u_c_6FWW23`]" ><a id="u_c_EQP124" href="javascript:;" v-for="(resetType, resetIndex) in compData.awardList" :key="resetIndex" v-html="resetType.resetName" :class="[`normal`,`u_c_EQP124`]" @click="u_c_EQP124_event_CEMW20($event,resetType.reset)"></a></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"awardList":[{"reset":"activity","resetName":"活动期间111","level":[{"gift":[{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16771430194596.png","special":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16771448857816.png","num":"10"},{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16771430194596.png","special":"","num":"20"}],"giftName":"活动奖励11\n活动奖励22"},{"gift":[{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16771430194596.png","special":"","num":0},{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16771430194596.png","special":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16771448857816.png","num":"30"},{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16771430194596.png","special":"","num":""}],"giftName":"活动奖励33\n活动奖励44"}]},{"reset":"lifetime","resetName":"终身222","level":[{"gift":[{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16668553474207.png","special":"","num":0}],"giftName":"终身奖励11"},{"gift":[{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16668553474207.png","special":"","num":0},{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16668553474207.png","special":"","num":"32"},{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16668553474207.png","special":"","num":0},{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16668553474207.png","special":"","num":0}],"giftName":"终身奖励22\n终身奖励22"},{"gift":[{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16668553474207.png","special":"","num":0},{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16668553474207.png","special":"","num":0},{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16668553474207.png","special":"","num":"3"},{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16668553474207.png","special":"","num":0},{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16668553474207.png","special":"","num":0}],"giftName":"终身奖励33\n终身奖励33\n终身奖励33\n终身奖励33\n 终身奖励33\n终身奖励33\n终身奖励33\n终身奖励33"},{"gift":[{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16668553474207.png","special":"","num":0}],"giftName":"终身奖励11"}]},{"reset":"weekly-2","resetName":"每双周333","level":[{"gift":[{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16671816069587.png","special":"","num":0},{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16671816069587.png","special":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16771448857816.png","num":"30"},{"pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16671816069587.png","special":"","num":""}],"giftName":"双周奖励11"}]}],"currency1":"","currency2":"","storeLink":`https://pay.blancozone.com/platform/officialWebStore.html?gameId=335#/`,"nowPreviewType":`activity`,"awardInfoBtn":true,"commonBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813847504721639.png`,"viewState":true},"zh-TW":{"awardList":[{"reset":"daily","resetName":"每日累儲","level":[{"gift":[{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784442470578.png","special":"","num":"80"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784411694119.png","special":"","num":"6"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784378152135.png","special":"","num":"4"}],"giftName":"仙桃*80，禦靈石*6，先天靈草*4"},{"gift":[{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784442470578.png","special":"","num":"100"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784411694119.png","special":"","num":"8"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784378152135.png","special":"","num":"4"}],"giftName":"仙桃*100，禦靈石*8，先天靈草*4"},{"gift":[{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784442470578.png","special":"","num":"150"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784411694119.png","special":"","num":"10"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784378152135.png","special":"","num":"4"}],"giftName":"仙桃*150，禦靈石*10，先天靈草*4"},{"gift":[{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784442470578.png","special":"","num":"200"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784411694119.png","special":"","num":"12"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784378152135.png","special":"","num":"5"}],"giftName":"仙桃*200，禦靈石*12，先天靈草*5"},{"gift":[{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784442470578.png","special":"","num":"250"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784411694119.png","special":"","num":"14"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784378152135.png","special":"","num":"6"}],"giftName":"仙桃*250，禦靈石*14，先天靈草*6"},{"gift":[{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784442470578.png","special":"","num":"400"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784411694119.png","special":"","num":"30"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784378152135.png","special":"","num":"20"}],"giftName":"仙桃*400，禦靈石*30，先天靈草*20"}]},{"reset":"activity","resetName":"活動累儲","level":[{"gift":[{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784341379900.png","special":"","num":"100"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784442470578.png","special":"","num":"300"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957090501321.png","special":"","num":"5"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957019032092.png","special":"","num":"40"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957018140696.png","special":"","num":"20"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957036902619.png","special":"","num":"5"}],"giftName":"仙玉*100，仙桃*300，引魂咒*5，天衍符+40，昆侖鐵*20，淨瓶水*5"},{"gift":[{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784341379900.png","special":"","num":"200"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784442470578.png","special":"","num":"350"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957090501321.png","special":"","num":"10"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957019032092.png","special":"","num":"50"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957018140696.png","special":"","num":"25"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957036902619.png","special":"","num":"10"}],"giftName":"仙玉*200，仙桃*350，引魂咒*10，天衍符+50，昆侖鐵*25，淨瓶水*10"},{"gift":[{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784341379900.png","special":"","num":"300"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784442470578.png","special":"","num":"400"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957090501321.png","special":"","num":"15"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957019032092.png","special":"","num":"60"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957018140696.png","special":"","num":"50"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957036902619.png","special":"","num":"20"}],"giftName":"仙玉*300，仙桃*400，引魂咒*15，天衍符+60，昆侖鐵*50，淨瓶水*20"},{"gift":[{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784341379900.png","special":"","num":"400"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784442470578.png","special":"","num":"500"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957090501321.png","special":"","num":"20"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957019032092.png","special":"","num":"80"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957018140696.png","special":"","num":"60"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957036902619.png","special":"","num":"40"}],"giftName":"仙玉*400，仙桃*500，引魂咒*20，天衍符+80，昆侖鐵*60，淨瓶水*40"},{"gift":[{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784341379900.png","special":"","num":"500"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784442470578.png","special":"","num":"600"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957090501321.png","special":"","num":"25"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957019032092.png","special":"","num":"120"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957018140696.png","special":"","num":"80"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957036902619.png","special":"","num":"60"}],"giftName":"仙玉*500，仙桃*600，引魂咒*25，天衍符+120，昆侖鐵*80，淨瓶水*60"},{"gift":[{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784341379900.png","special":"","num":"600"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784442470578.png","special":"","num":"700"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957090501321.png","special":"","num":"30"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957019032092.png","special":"","num":"160"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957018140696.png","special":"","num":"100"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957036902619.png","special":"","num":"80"}],"giftName":"仙玉*600，仙桃*700，引魂咒*30，天衍符+160，昆侖鐵*100，淨瓶水*80"},{"gift":[{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784341379900.png","special":"","num":"700"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784442470578.png","special":"","num":"800"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957090501321.png","special":"","num":"35"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957019032092.png","special":"","num":"200"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957018140696.png","special":"","num":"120"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957036902619.png","special":"","num":"100"}],"giftName":"仙玉*700，仙桃*800，引魂咒*35，天衍符+200，昆侖鐵*120，淨瓶水*100"},{"gift":[{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784341379900.png","special":"","num":"800"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784442470578.png","special":"","num":"900"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957090501321.png","special":"","num":"40"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957019032092.png","special":"","num":"220"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957018140696.png","special":"","num":"130"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957036902619.png","special":"","num":"110"}],"giftName":"仙玉*800，仙桃*900，引魂咒*40，天衍符+220，昆侖鐵*130，淨瓶水*110"},{"gift":[{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784341379900.png","special":"","num":"900"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881784442470578.png","special":"","num":"1000"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957090501321.png","special":"","num":"50"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957019032092.png","special":"","num":"240"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957018140696.png","special":"","num":"140"},{"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/169881957036902619.png","special":"","num":"120"}],"giftName":"仙玉*900，仙桃*1000，引魂咒*50，天衍符+240，昆侖鐵*140，淨瓶水*120"}]}],"currency1":"","currency2":"","storeLink":`https://pay.blancozone.com/platform/officialWebStore.html?gameId=335#/`,"nowPreviewType":`activity`,"awardInfoBtn":true,"commonBg":`https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813847504721639.png`,"viewState":true}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['zh-TW']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '充值领奖';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const initActivity = inject("initActivity", () => {})
const canClickRefresh = inject("canClickRefresh", true)
const listData = inject("listData", {})
const showTips = inject("showTips", (txt) => {})
const getMoneyWithUnit = inject("getMoneyWithUnit",(num) => {});

// 链接拼接
const assignQueryParam = (target) => {
  const targetURL = new URL(target)
  const targetParam = new URLSearchParams(targetURL.search)
  const urlParam = new URLSearchParams(window.location.search)
  for (let key of urlParam.keys()) {
    targetParam.set(key, urlParam.get(key))
  }
  const finalLink = `${targetURL.origin}${targetURL.pathname}?${targetParam.toString()}`
  console.log(finalLink)
  return finalLink;
}
const init = () => {
  compData.viewState=true;
  compData.nowPreviewType = ''
  compData.storeLink = assignQueryParam(compData.storeLink)
  compData.awardList.forEach((item, index) => {
    let levelArray = item.level;
    levelArray.forEach((item, index) => {
      item.state = -1
    })
  })
}
init();
const AWARDLIST = _.cloneDeep(compData.awardList);
watch(
  () => listData,
  (value) => {
    if (value && value.awardList) {
      let confList = _.cloneDeep(AWARDLIST)
      let backTypeList = Object.keys(value.awardList) // 后端接口返回的类型
      compData.awardList = []
      let levelArray = []
      backTypeList.forEach((type) => {
        levelArray = []
        let frontType = confList.filter(item => item.reset === type) // 自动化配置的内容
        if (frontType.length) { // 前端有配对应类型
          let frontLevelArray = frontType[0].level // 自动化配置的档位内容
          // 更新底部重置按钮显示文案
          pageData.resetTextMap[type] = frontType[0].resetName;
          let backLevelArray = Object.values(value.awardList[type]) // 后端接口对应的内容           
          frontLevelArray.forEach((item, index) => {
            if (backLevelArray.length > index) {
              levelArray.push({
                gift: item.gift,
                state: backLevelArray[index].state ?? -1,
                level: backLevelArray[index].real_level || 0,
                levelToGetAward: backLevelArray[index].level || 0, // 调用领奖接口用的level值，大麦初始值
                levelWithCurrency: getMoneyWithUnit(backLevelArray[index].real_level), // 带货币单位的金额数值
                giftName: item.giftName
              })
            }
          })
          compData.awardList.push({
            reset: type,
            resetName:frontType[0].resetName,
            level: levelArray,
          })
        }
      })
      pageData.awardList = compData.awardList
    }
  },
  { deep: true }
)

const canClickAward = ref(true);
const getAward = async (level, type, index) => {
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=pickGift`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=pickGift`,
    jp:`https://jpeventsapi.37games.com/activity/execute?name=${pageData.pageId}&action=pickGift`
  };
  let res = await request.getJSON(link[pagePlatform], {
    params: JSON.stringify({
      level,
      type
    }),
  });
  if (res.result == 1) {
    let targetResetList = compData.awardList.find(item => item.reset === pageData.nowResetType)

    targetResetList.level[index].state = 1;
    if (res.data.send_value) {
      pageData.nowGiftCode = res.data.send_value;
      pageData.giftCodePopupState = true
    }
  } else {
    showTips(getLangTxt(res.code, `${getLangTxt("common")}[${res.code}]`));
  }
  return res.result == 1;
};;
      // 刷新按钮的click事件
      const u_c_DG4T22_event_UCCO40= async (e)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if(!canClickRefresh.value)return;
canClickRefresh.value = false;
initActivity();
await utils.sleep(5);
canClickRefresh.value = true;} catch (error) {console.log(error)}
      };
      // 查看奖励详情按钮的click事件
      const u_c_QY0H88_event_CJ5D36= async (e,txt)=>{
        try {pageData.awardDetail = txt
pageData.awardContentPopupState = true} catch (error) {console.log(error)}
      };
      // 可领取按钮的click事件
      const u_c_TWA791_event_YQ8637= async (e,level,type,index)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if(!canClickAward.value)return
canClickAward.value = false
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: `点击领奖`,
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
await getAward(level,type,index)
canClickAward.value = true} catch (error) {console.log(error)}
      };
      // 未达成去储值按钮的click事件
      const u_c_7B8431_event_A5YB17= async (e)=>{
        try {bridge.open(compData.storeLink)} catch (error) {console.log(error)}
      };
      // 储值类型的click事件
      const u_c_EQP124_event_CEMW20= async (e,type)=>{
        try {pageData.nowResetType=type
const pointMap =  {
  "activity":"活动期间累充",
  "lifetime":"终身累充",
  "daily":"每日累充",
  "monthly":"每月累充",
  "weekly-1": "每周累充",
  "weekly-2": "每双周累充",
  "weekly-3": "每三周累充",
  "weekly-4": "每四周累充",
}
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: pointMap[type],
  gameId: pageData.gameId,
  aid: pageData.pageId,
})} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_G8HA65.normal{
position:relative;
width:10.00rem;
height:0;
background-size:cover;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16661615581826.jpg);
font-size:0;
margin:auto;

}
}.default{
.u_c_4MZY17.normal{
position:relative;
width:100%;
height:21.37rem;
background-size:contain;
margin:0 auto;
margin-top:0.16rem;
overflow:hidden;
box-sizing:border-box;
background-repeat:no-repeat;

}

.u_c_4MZY17.normal .txtColor{
color:#694600;

}

.u_c_4MZY17.normal .tipsFontSize{
font-size:0.27rem;

}
}.default{
.u_c_1MRM21.normal{
position:relative;
display:flex;
justify-content:center;
margin:0 auto;
margin-top:0.33rem;
font-weight:600;
text-align:center;
font-size:0.33rem;
width:9.36rem;

}
}.default{
.u_c_8HBX18.normal{
position:relative;
width:9.05rem;
height:0.80rem;
margin:0 auto;
margin-top:0.17rem;
background-size:contain;
display:flex;
justify-content:center;
align-items:center;
color:#787566;
font-size:0.40rem;
font-weight:600;

}
}.default{
.u_c_5ILV19.normal{
position:relative;
top:-0.04rem;

}
}.default{
.u_c_5TL728.normal{
position:relative;
top:-0.04rem;

}
}.default{
.u_c_57DD20.normal{
position:relative;
display:flex;
justify-content:center;
margin:0 auto;
width:80%;
margin-top:0.07rem;
white-space:nowrap;

}
}.default{
.u_c_XO0080.normal{
position:relative;

}
}.default{
.u_c_Z99V79.normal{
position:relative;

}
}.default{
.u_c_DG4T22.normal{
position:relative;
width:3.44rem;
height:0.61rem;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813843799835309.png);
font-size:0.33rem;
text-decoration:none;
margin:0 auto;
margin-top:0.23rem;
color:#51675f;

}
}.default{
.u_c_EM0285.normal{
position:relative;
display:flex;
flex-direction:column;
justify-content:flex-start;
align-items:center;
margin-top:0.44rem;
flex-shrink:0;
height:78%;
overflow-y:scroll;

}
}.default{
.u_c_PLQE86.normal{
position:relative;
width:9.24rem;
height:5.45rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813847523418323.png);
margin-bottom:0.13rem;
display:flex;
align-items:center;
justify-content:center;
flex-direction:column;
background-size:100% 100%;
flex:none;

}

.u_c_PLQE86.normal .award-btn{
width:5.41rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813857522415765.png);
display:flex;
align-items:center;
justify-content:center;
background-size:100% 100%;
font-size:0.44rem;
color:#fff;
text-decoration:none;

}
}.default{
.u_c_QY0H88.normal{
position:absolute;
width:1.37rem;
height:0.92rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813847561343993.png);
display:flex;
align-items:center;
justify-content:center;
font-size:0.28rem;
background-size:100% 100%;
color:#fff;
text-decoration:none;
right:0;
top:0;
text-align:center;

}
}.default{
.u_c_V9GG87.normal{
position:relative;
font-size:0.33rem;
display:flex;
align-items:center;
margin-top:0.13rem;
color:#453218;
margin-right:1.81rem;

}
}.default{
.u_c_20QV21.normal{
position:relative;
width:8.67rem;
margin-top:0.55rem;
display:flex;
overflow-x:auto;
flex:none;

}

.u_c_20QV21.normal::-webkit-scrollbar{
display:none;

}
}.default{
.u_c_11Y490.normal{
position:relative;
width:1.28rem;
height:1.28rem;
background-size:contain;
margin-right:0.13rem;
background-repeat:no-repeat;
flex:none;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_NFW650.normal{
position:absolute;
width:1.28rem !important;
height:1.28rem !important;
background-size:100% 100%;
left:0;
top:0;

}
}.default{
.u_c_L7EQ52.normal{
position:relative;
width:0.93rem !important;
height:0.93rem !important;
background-size:contain;

}
}.default{
.u_c_ZHKH20.normal{
position:absolute;
right:0.07rem;
bottom:0.07rem;
font-size:0.24rem;
color:#fff;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16771380717253.png);
width:0.51rem;
height:0.43rem;
display:flex;
justify-content:center;
align-items:center;
background-size:100% 100%;

}
}.default{
.u_c_TWA791.normal{
position:relative;
margin-top:0.61rem;

}
}.default{
.u_c_7B8431.normal{
position:relative;
margin-top:0.37rem;

}
}.default{
.u_c_9MI432.normal{
position:relative;
margin-top:0.37rem;

}
}.default{
.u_c_VO2492.normal{
position:relative;
display:block;
font-size:0.27rem;
color:#7e0e0e;
padding:0.13rem 0;

}
}.default{
.u_c_6FWW23.normal{
position:fixed;
width:10.00rem;
height:1.33rem;
left:50%;
bottom:0.20rem;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
transform:translateX(-50%);
background-size:100% 100%;

}
}.default{
.u_c_EQP124.normal{
position:relative;
width:5.41rem;
height:1.07rem;
display:flex;
align-items:center;
justify-content:center;
color:#fffada;
font-size:0.33rem;
background-repeat:no-repeat;
background-size:100% 100%;
text-decoration:none;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813864663070104.png);
font-weight:600;

}
}.zh-TW{
.u_c_G8HA65.normal{
position:relative;
width:10.00rem;
height:0;
background-size:cover;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/10/16661615581826.jpg);
font-size:0;
margin:auto;

}
}.zh-TW{
.u_c_4MZY17.normal{
position:relative;
width:100%;
height:21.37rem;
background-size:contain;
margin:0 auto;
margin-top:0.16rem;
overflow:hidden;
box-sizing:border-box;
background-repeat:no-repeat;

}

.u_c_4MZY17.normal .txtColor{
color:#694600;

}

.u_c_4MZY17.normal .tipsFontSize{
font-size:0.27rem;

}
}.zh-TW{
.u_c_1MRM21.normal{
position:relative;
display:flex;
justify-content:center;
margin:0 auto;
margin-top:0.33rem;
font-weight:600;
text-align:center;
font-size:0.33rem;
width:9.36rem;

}
}.zh-TW{
.u_c_8HBX18.normal{
position:relative;
width:9.05rem;
height:0.80rem;
margin:0 auto;
margin-top:0.17rem;
background-size:contain;
display:flex;
justify-content:center;
align-items:center;
color:#787566;
font-size:0.40rem;
font-weight:600;

}
}.zh-TW{
.u_c_5ILV19.normal{
position:relative;
top:-0.04rem;

}
}.zh-TW{
.u_c_5TL728.normal{
position:relative;
top:-0.04rem;

}
}.zh-TW{
.u_c_57DD20.normal{
position:relative;
display:flex;
justify-content:center;
margin:0 auto;
width:80%;
margin-top:0.07rem;
white-space:nowrap;

}
}.zh-TW{
.u_c_XO0080.normal{
position:relative;

}
}.zh-TW{
.u_c_Z99V79.normal{
position:relative;

}
}.zh-TW{
.u_c_DG4T22.normal{
position:relative;
width:3.44rem;
height:0.61rem;
background-size:100% 100%;
display:flex;
justify-content:center;
align-items:center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813843799835309.png);
font-size:0.33rem;
text-decoration:none;
margin:0 auto;
margin-top:0.23rem;
color:#51675f;

}
}.zh-TW{
.u_c_EM0285.normal{
position:relative;
display:flex;
flex-direction:column;
justify-content:flex-start;
align-items:center;
margin-top:0.44rem;
flex-shrink:0;
height:78%;
overflow-y:scroll;

}
}.zh-TW{
.u_c_PLQE86.normal{
position:relative;
width:9.24rem;
height:5.45rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813847523418323.png);
margin-bottom:0.13rem;
display:flex;
align-items:center;
justify-content:center;
flex-direction:column;
background-size:100% 100%;
flex:none;

}

.u_c_PLQE86.normal .award-btn{
width:5.41rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813857522415765.png);
display:flex;
align-items:center;
justify-content:center;
background-size:100% 100%;
font-size:0.44rem;
color:#fff;
text-decoration:none;

}
}.zh-TW{
.u_c_QY0H88.normal{
position:absolute;
width:1.37rem;
height:0.92rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813847561343993.png);
display:flex;
align-items:center;
justify-content:center;
font-size:0.28rem;
background-size:100% 100%;
color:#fff;
text-decoration:none;
right:0;
top:0;
text-align:center;

}
}.zh-TW{
.u_c_V9GG87.normal{
position:relative;
font-size:0.33rem;
display:flex;
align-items:center;
margin-top:0.13rem;
color:#453218;
margin-right:1.81rem;

}
}.zh-TW{
.u_c_20QV21.normal{
position:relative;
width:8.67rem;
margin-top:0.55rem;
display:flex;
overflow-x:auto;
flex:none;

}

.u_c_20QV21.normal::-webkit-scrollbar{
display:none;

}
}.zh-TW{
.u_c_11Y490.normal{
position:relative;
width:1.28rem;
height:1.28rem;
background-size:contain;
margin-right:0.13rem;
background-repeat:no-repeat;
flex:none;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_NFW650.normal{
position:absolute;
width:1.28rem !important;
height:1.28rem !important;
background-size:100% 100%;
left:0;
top:0;

}
}.zh-TW{
.u_c_L7EQ52.normal{
position:relative;
width:0.93rem !important;
height:0.93rem !important;
background-size:contain;

}
}.zh-TW{
.u_c_ZHKH20.normal{
position:absolute;
right:0.07rem;
bottom:0.07rem;
font-size:0.24rem;
color:#fff;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16771380717253.png);
width:0.51rem;
height:0.43rem;
display:flex;
justify-content:center;
align-items:center;
background-size:100% 100%;

}
}.zh-TW{
.u_c_TWA791.normal{
position:relative;
margin-top:0.61rem;

}
}.zh-TW{
.u_c_7B8431.normal{
position:relative;
margin-top:0.37rem;

}
}.zh-TW{
.u_c_9MI432.normal{
position:relative;
margin-top:0.37rem;

}
}.zh-TW{
.u_c_VO2492.normal{
position:relative;
display:block;
font-size:0.27rem;
color:#7e0e0e;
padding:0.13rem 0;

}
}.zh-TW{
.u_c_6FWW23.normal{
position:fixed;
width:10.00rem;
height:1.33rem;
left:50%;
bottom:0.20rem;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
transform:translateX(-50%);
background-size:100% 100%;

}
}.zh-TW{
.u_c_EQP124.normal{
position:relative;
width:5.41rem;
height:1.07rem;
display:flex;
align-items:center;
justify-content:center;
color:#fffada;
font-size:0.33rem;
background-repeat:no-repeat;
background-size:100% 100%;
text-decoration:none;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813864663070104.png);
font-weight:600;

}
}
</style>
